import React, { useState } from "react";
import List from "./List";
import { Modal, Button } from 'semantic-ui-react';



const Household = () => {

  return (
    <div className="household container">
      <List />
    </div>
  );
};

export default Household;
